package com.wintermar.inspection.core.ui.theme.color.palette

import androidx.compose.ui.graphics.Color
import com.wintermar.inspection.core.ui.theme.color.model.ColorVariant

val InfoColorVariant = ColorVariant(
    n25 = Color(0xFFF5FAFF),
    n50 = Color(0xFFEFF8FF),
    n100 = Color(0xFFD1E9FF),
    n200 = Color(0xFFB2DDFF),
    n300 = Color(0xFF84CAFF),
    n400 = Color(0xFF53B1FD),
    n500 = Color(0xFF2E90FA),
    n600 = Color(0xFF1570EF),
    n700 = Color(0xFF175CD3),
    n800 = Color(0xFF1849A9),
    n900 = Color(0xFF194185)
)
